import type { ChatScopeFilters } from "../../api";
import type { FilterOption } from "../FilterMultiSelect";
import type { MentionCandidate } from "../watchlist/mentions";

/** An initial mention narrows All; subsequent mentions add to an explicit selection. */
export function filtersWithMention(
  filters: ChatScopeFilters,
  candidate: MentionCandidate,
  users: FilterOption[],
): ChatScopeFilters {
  const next = { ...filters, instanceIds: undefined, selectedSteps: undefined };
  if (candidate.kind === "person") {
    if (candidate.selectAll) return { ...next, userIds: users.map(user => user.id) };
    const allPeople = !filters.userIds || users.every(user => filters.userIds!.includes(user.id));
    return {
      ...next,
      userIds: [...new Set([...(allPeople ? [] : filters.userIds!), candidate.id])],
    };
  }
  if (candidate.selectAll) return { ...next, processes: undefined };
  return {
    ...next,
    processes: [
      ...new Set([...(filters.instanceIds ? [] : (filters.processes ?? [])), candidate.label]),
    ],
  };
}
